import * as moment from 'moment-timezone';

export function calculateAgeWithTimezone(birthDate: string, timeZone: string): number | null {
  let dateObj: any = null;
  if (birthDate.includes('-')) {
    dateObj = moment.tz(birthDate, timeZone);
  } else if (birthDate.includes('/')) {
    const [month, day, year] = birthDate.split('/').map(Number);
    dateObj = moment.tz({ year, month: month - 1, day }, timeZone);
  }
  if (!dateObj || !dateObj.isValid()) return null;
  const now = moment.tz(timeZone);
  let age = now.year() - dateObj.year();
  if (now.month() < dateObj.month() || (now.month() === dateObj.month() && now.date() < dateObj.date())) {
    age--;
  }
  return age;
}

export function calculateAge(birthDate: string): number | null {
  let dateObj: Date | null = null;
  if (birthDate.includes('-')) {
    dateObj = new Date(birthDate);
  } else if (birthDate.includes('/')) {
    const [month, day, year] = birthDate.split('/').map(Number);
    dateObj = new Date(year, month - 1, day);
  }
  if (!dateObj || isNaN(dateObj.getTime())) return null;
  const today = new Date();
  let age = today.getFullYear() - dateObj.getFullYear();
  if (dateObj) {
    const m = today.getMonth() - dateObj.getMonth();
    if (m < 0 || (m === 0 && today.getDate() < dateObj.getDate())) {
      age--;
    }
  }
  return age;
}
